<style lang="sass" rel="stylesheet/sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import sass/link
@import sass/btn
@import sass/btnRound
</style>
<script>
import Vue from 'vue'
import dataLayer from 'library/src/core/dataLayer'
import { oneOf } from '../../assets/js/utils/assist'

const LINK_CLASS = 'g_link'
const BUTTON_CLASS = 'g_btn'

export default {
    name: 'cta',
    props: {
        isLink: {
            type: Boolean,
            default: false
        },
        isBtn: {
            type: Boolean,
            default: false
        },
        link: String,
        linkMobile: String,
        scrollTo: String,
        type: {
            type: String,
            required: true,
            validator: function (value) {
                return oneOf(value, [
                    'text',
                    'button'
                ])
            }
        },
        classNameContent: {},
        fontIcon: String,
        content: String
    },
    methods: {
        handleClick () {
            this.$emit('click')
            // Run scroll to element
            if (this.scrollTo) {
                const [anchor, minus] = this.scrollTo.split(',')
                this._goToSmooth(anchor[0] !== '#' ? '#' + anchor : anchor, minus)
            } else if (this.type === 'button' && (this.linkMobile || this.link)) {
                location.href = this.getLink()
            }
        },
        hasIcon () {
            return this.icon || this.fontIcon
        },
        getLink () {
            return dataLayer.isMobile && this.linkMobile !== '' ? this.linkMobile : this.link
        }
    },
    beforeMount () {
        if (this.hasIcon()) {
            Vue.component('Visual', () => import(/* webpackChunkName: "Visual" */ '../Visual').then(m => m.default))
        }
    },
    render (createElement) {
        const classNames = []
        const attrs = {}
        let el

        if (this.type === 'button') {
            el = 'button'
            if (this.scrollTo) {
                import(/* webpackChunkName: "scrollTo" */ '../../assets/js/mixins/scrollTo')
                    .then(goToSmooth => {
                        this._goToSmooth = goToSmooth.default
                    })
            }
        } else {
            el = 'a'
            attrs.href = this.getLink()
        }
        if (this.isLink) {
            classNames.push(LINK_CLASS)
        } else if (this.isBtn) {
            classNames.push(BUTTON_CLASS)
        }

        let span
        if (this.content) {
            span = createElement(
                'span',
                {
                    attrs: {
                        class: this.classNameContent
                    },
                    domProps: {
                        innerHTML: this.content
                    }
                }
            )
        }

        let fontIcon
        if (this.fontIcon) {
            fontIcon = createElement(
                'Visual',
                {
                    attrs: {
                        fontIcon: this.fontIcon
                    }
                }
            )
        }

        return createElement(
            el,
            {
                class: classNames,
                attrs,
                on: {
                    click: evt => this.handleClick(evt)
                }
            },
            [this.$slots.default, span, fontIcon, this.$slots.after]
        )
    }
}
</script>
